import {
  ActionType,
  StepAction,
  StepType,
  TutorialConfig,
  TutorialStep,
} from "../types/tutorial-config"

let stepCounter = 0
const nextStepId = (prefix: string): string => {
  stepCounter += 1
  return `${prefix}-${stepCounter}-${Date.now().toString(36).slice(-4)}`
}

export const emptyConfig = (simulationId: number): TutorialConfig => ({
  version: "1.0",
  simulationId,
  meta: { name: "", description: "" },
  variables: {},
  messages: [],
  searchTriggers: [],
  treeNodeTriggers: [],
  treeNodeMappings: [],
  steps: [],
})

export const newStep = (type: StepType): TutorialStep => {
  const base: TutorialStep = {
    id: nextStepId(type),
    type,
    text: "",
  }
  switch (type) {
    case "click-advance":
      return {
        ...base,
        attachTo: { element: "", on: "bottom" },
        advanceOn: { selector: "", event: "click" },
      }
    case "search-wait":
      return {
        ...base,
        attachTo: { element: "#treeSearchInput", on: "bottom" },
        advanceOn: { selector: "body", event: "" },
      }
    case "tree-select":
      return {
        ...base,
        attachTo: { element: "", on: "right" },
        advanceOn: { selector: "", event: "click" },
      }
    case "drag-drop":
      return {
        ...base,
        attachTo: { element: "", on: "bottom" },
        advanceOn: { selector: "", event: "" },
      }
    case "modal-wait":
      return {
        ...base,
        waitForElement: "",
        advanceOn: { selector: "", event: "click" },
      }
    case "final":
      return {
        ...base,
        buttons: [{ text: "Done", action: "complete" }],
      }
    case "standard":
    default:
      return base
  }
}

export const newAction = (action: ActionType): StepAction => ({
  action,
  target: "",
})
